import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
    palette: {
        primary: {
            main:'#0d47a1',
            dark: '#1565c0',
            light: '#1976d2',
            contrastText: '#ffffff',
        },
        secondary: {
            main:'#FFC436',
            dark: '#FFA33C',
            light: '#F9B824',
            contrastText: '#000000',
        },
        background: {
            paper: '#ffffff',
            default: '#f7f6f3',
        }
    },
    typography: {
        fontFamily: 'Arial, sans-serif',
    },
});

const darkTheme = createTheme({
    palette: {
        primary: {
            main:'#0d47a1',
            dark: '#1565c0',
            light: '#1976d2',
            contrastText: '#ffffff',
        },
        secondary: {
            main:'#FFC436',
            dark: '#FFA33C',
            light: '#F9B824',
            contrastText: '#000000',
        },
        background: {
            paper: '#ffffff',
            default: '#f7f6f3',
        }
    },
    typography: {
        fontFamily: 'Arial, sans-serif',
    },
});

export { lightTheme, darkTheme };
